<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Current Inbound Reference</label>
        <vs-input
          class="w-full"
          v-model="oldReference"
          placeholder="Enter current reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="oldReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <!-- Preview Section -->
    <div class="vx-row mt-6" v-if="showPreview" style="display:flex;align-items:stretch;">
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Inbound Info</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:40%;">Supplier</td>
              <td style="padding:4px 0;">{{ previewData.supplier_name }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Client</td>
              <td style="padding:4px 0;">{{ previewData.client_name }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Warehouse</td>
              <td style="padding:4px 0;">{{ previewData.warehouse_name }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Status</td>
              <td style="padding:4px 0;">{{ previewData.status }}</td>
            </tr>
          </table>
        </vs-card>
      </div>

      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Records Akan Diupdate</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:50%;">Inbound</td>
              <td style="padding:4px 0;">1 record</td>
            </tr>
          </table>
        </vs-card>
      </div>
    </div>

    <!-- New Reference Input -->
    <div class="vx-row mt-6" v-if="showPreview">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label">New Inbound Reference</label>
        <vs-input
          class="w-full"
          v-model="newReference"
          placeholder="Enter new reference"
          @keyup.enter="submitForm"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="primary"
          class="btn mb-4 md:mb-0"
          @click="submitForm"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Confirm Modal -->
    <vs-popup title="Konfirmasi Update Inbound Reference" :active.sync="showConfirmModal">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin memperbarui inbound reference?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">Current Reference</td>
          <td style="padding:4px 0;">{{ oldReference }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">New Reference</td>
          <td style="padding:4px 0;">{{ newReference }}</td>
        </tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="primary" class="btn" @click="confirmUpdate">Ya, Update</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      oldReference: "",
      newReference: "",
      previewData: null,
      showPreview: false,
      showConfirmModal: false,
    };
  },
  methods: {
    searchPreview() {
      if (this.oldReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Old Inbound Reference is required",
        });
        return false;
      }

      this.$emit("loading", true);
      this.showPreview = false;

      this.$http
        .post("support/inbound/preview", {
          reference: this.oldReference,
        })
        .then((res) => {
          this.$emit("loading", false);
          this.previewData = res.data.data;
          this.showPreview = true;
          this.newReference = "";
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },

    submitForm() {
      if (this.newReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "New Inbound Reference is required",
        });
        return false;
      }

      if (this.oldReference === this.newReference) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Old and new reference are the same",
        });
        return false;
      }

      this.showConfirmModal = true;
    },

    confirmUpdate() {
      this.showConfirmModal = false;
      this.$emit("loading", true);

      this.$http
        .post("support/inbound/update", {
          old_reference: this.oldReference,
          new_reference: this.newReference,
        })
        .then((res) => {
          this.$emit("loading", false);
          const data = res.data.data;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: `Inbound reference "${data.old_reference}" berhasil diperbarui menjadi "${data.new_reference}".`,
          });
          this.oldReference = "";
          this.newReference = "";
          this.previewData = null;
          this.showPreview = false;
        })
        .catch((error) => this.$emit("error", error));
    },
  },
};
</script>
